module.exports = __webpack_public_path__ + "static/media/digitazon.a8056a53.png";